import type { PublicTrace } from '@onefootprint/request-types/dashboard';
import getRulePathSteps from './get-rule-path-steps';

/** How many rules fired on the path the trace took, and how many nodes skipped theirs for a sandbox outcome. */
const getTraceRuleCounts = (trace: PublicTrace) => {
  const steps = getRulePathSteps(trace);
  return {
    triggered: steps.reduce((count, { conditions }) => count + conditions.length, 0),
    skipped: steps.filter(({ isNotEvaluated }) => isNotEvaluated).length,
  };
};

export default getTraceRuleCounts;
